<template>

<div>

    <lightbox activateCommand="open_add_single_CreatorProfileModal" deactivateCommand="close_add_single_CreatorProfileModal" customClass="bg-color-darkgray rounded-border" style="z-index: 99999;" special_lightbox="select_creator_profile_lightbox">
        <div class="flex flex-wrap col-12 max-width-4 ui-modal  ui-modal--settings white">
            <div class="col-6">
            <div class="flex align-middle mb1">
                <p class="col-4 small" v-bind:class="{ userprofileError: not_filled_title}">{{$t('creator_profile_administration_profile_name')}}*</p>
            <input class="user-input-narrow col-8 border-box" :placeholder="$t('creator_profile_administration_profile_name_placeholder')" v-model="userProfile.title">
            </div>
          
            <div class="flex align-middle mb1">
                <p class="col-4 small" v-bind:class="{ userprofileError: not_filled_company}">{{$t('creator_profile_administration_company')}}*</p>
                <input class="user-input-narrow col-8 border-box" :placeholder="$t('creator_profile_administration_company_placeholder')" v-model="userProfile.company">
            </div>
                <div class="flex align-middle rowsys mb1">
                <p class="small col-2" v-bind:class="{ userprofileError: not_filled_email}">{{$t('creator_profile_administration_email')}}*</p>
                <div class="col-2">
                <div class="switch relative dark pointer" @click="changeFreeMail(userProfile.freeMail)">
                    <div class="switch-ball" :class="{sbLeft: userProfile.freeMail == 0}"></div>
                </div> 
                </div>
                <input v-show="userProfile.freeMail == 1" class="user-input-narrow col-8 border-box" :placeholder="$t('creator_profile_administration_email_placeholder')" v-model="userProfile.email">
                <input disabled v-show="userProfile.freeMail == 0" class="user-input-narrow  no-border col-8 border-box npe" :placeholder="$t('creator_profile_administration_email_placeholder')" v-model="userdata.email">
            </div> 
                <div class="flex align-middle mb1">
                <p class="col-2 small " v-bind:class="{ userprofileError: not_filled_phone}">{{$t('creator_profile_administration_phone')}}*</p>
                <div class="col-2">
                <div class="switch dark relative pointer" @click="changeFreePhone(userProfile.freePhone)">
                    <div class="switch-ball" :class="{sbLeft: userProfile.freePhone == 0}"></div>
                </div> 
                </div>
                <input v-show="userProfile.freePhone == 1" class="user-input-narrow col-8 border-box" :placeholder="$t('creator_profile_administration_phone_placeholder')" v-model="userProfile.phone">
                <input disabled v-show="userProfile.freePhone == 0" class="user-input-narrow  no-border col-8 border-box npe" :placeholder="$t('creator_profile_administration_phone_placeholder')" v-model="userdata.tel">
            </div>
            <div class="flex align-middle mb1">
                <p class="col-4 small" v-bind:class="{ userprofileError: not_filled_creator_name}">{{$t('creator_profile_administration_creator_name')}}*</p>
                <input class="user-input-narrow col-8 border-box" :placeholder="$t('creator_profile_administration_creator_name')" v-model="userProfile.creator_name">
            </div>
            </div>
            <div class="col-6 pl2 border-box ">
            <div class="flex align-middle mb1 col-12">
                <p class="col-4  small" v-bind:class="{ userprofileError: not_filled_address1}">{{$t('creator_profile_administration_address_1')}}*</p>
                <input class="user-input-narrow  col-8 border-box" v-model="userProfile.address1"/>
            </div>
            <div class="flex align-middle mb1 col-12 row-sys">
                <p class="col-4 small">{{$t('creator_profile_administration_address_2')}}</p>
                <input class="user-input-narrow  col-8 border-box" v-model="userProfile.address2"/>
            </div>
            <div class="flex align-middle mb1 col-12 row-sys">
                <p class="col-4 small">{{$t('creator_profile_administration_address_3')}}</p>
                <input class="user-input-narrow  col-8 border-box" v-model="userProfile.address3"/>
            </div>
            <div class="flex align-middle mb1 col-12 row-sys">
                <p class="col-4  small " v-bind:class="{ userprofileError: not_filled_country}">{{$t('creator_profile_administration_country')}}*</p>
                <div class="relative user-select-wrapper col-8 border-box">
                <img class="dropdown-arrow" src="../assets/dropdown-arrow.svg">
                <select class="user-input-narrow  col-12" id="CountrySelect" name="CountrySelect" v-model="userProfile.country_id">
                    <option value="" disabled>{{$t('creator_profile_administration_country')}}</option>
                    <option v-for="country in countries_list.data" :key="country.id" :value="country.id">
                    {{ country.countryname }}
                    </option>
                </select> 
                </div>
            </div>
            <div class="flex mt2">
                <div class="col-4">
                 <p class="small ">{{$t('creator_profile_administration_logo')}}</p>
                <p class="color-mediumgray  small mr2">{{$t('creator_profile_administration_logo_maxMB')}}</p>
                </div>
                <!-- <img :src="userProfile.previewimage"> -->
                <div class="flex mb1 col-8">
                <div v-if="userProfile.previewimage !== ''" @click="selectImage"  :style="{ 'background-image': `url(${userProfile.previewimage.replace(/(\r\n|\n|\r)/gm, '')})` }" class="p4 rounded-border overflow-hidden bg-color-gray company-img-container"></div>
                <div class="">
                    <input class="hidden-file-upload" ref="fileInput" type="file" name="Datei hochladen" @input="pickFile"> 
                    <div class="flex flex-column" :class="{'ml3': userProfile.previewimage !== ''}">
                    <button class="btn btn-tiny pointer mb2" @click="selectImage">{{$t('creator_profile_administration_upload_pic')}}</button>
                    <button class="btn btn-bg-red btn-small pointer" v-if="userProfile.previewimage !== ''" @click="userProfile.previewimage = ''">{{$t('creator_profile_administration_delete_pic')}}</button>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
         <div class="divider my2 mx0 col-12"></div>
        <div class="col-12 flex justify-end ">
         
          <button class="btn btn-bg-red btn-small pointer" @click="closeAddCreatorProfile()">{{$t('creator_profile_administration_cancel')}}</button>
          <button class="btn btn-small pointer ml3" @click="addCreatorProfile()">{{$t('creator_profile_administration_add_profile')}}</button>
        </div>
    </lightbox>

    <lightbox activateCommand="open_creatorProfileSelection" deactivateCommand="close_creatorProfileSelection" customClass="bg-color-darkgray rounded-border ui-modal--settings max-width-4">
      <!-- <div class="flex flex-column col-12">
        <h2 class="h3 mb3 white">Wählen sie das Erstellerprofil, mit dem das PDF generiert werden soll.</h2>
        <div class=" row-sys flex mb2 align-middle col-12">
          <p class="col-3 white">{{$t('eingabe_modal_newcalc_creatorprofile')}}</p>
          <div class="relative user-select-wrapper col-8 border-box">
            <select class="user-input-narrow col-12 pointer" v-model="inputParams.in_creators_id">
              <option value="0" disabled>{{$t('eingabe_modal_newcalc_fireprevention_proof_pleaseselect')}}</option>
              <option v-for="profile in creator_profiles" :key="profile.id" :value="profile.id">
              {{ profile.title }}
              </option>
            </select>
          </div>
        </div>
      </div> -->
          <h2 class=" col-12 h2 white">{{$t('eingabe_modal_select_creator_profile_heading_topline')}}</h2>
          <h2 class=" col-12 h2 mb3 white">{{$t('eingabe_modal_select_creator_profile_heading')}}</h2>
          <div v-show="creator_profiles.length !== 0"  class="flex col-12 flex-reverse1 white  ">
              <div class="col-6 pl1 bg-black rounded-border p2">
                <div class="flex align-middle justify-between mb2">
                  <h2 class="p col-6">{{$t('eingabe_modal_select_creator_profile_chosen_profile')}}</h2>
                  <p class="p col-6">{{selected_profile.title}}</p>
                </div>
                <div v-if="selected_profile.creator_name !== ('' && ' ' )" class="flex align-middle justify-between mb2">
                  <p class=" small col-6">{{$t('eingabe_modal_select_creator_profile_creator_name')}}</p>
                  <p class="p col-6">{{selected_profile.creator_name}}</p>
                </div>
                <div v-if="selected_profile.email !== ('' && ' ' )" class="flex align-middle justify-between mb2">
                  <p class="  col-6">{{$t('eingabe_modal_select_creator_profile_email')}}</p>
                  <p class="p col-6">{{selected_profile.email}}</p>
                </div>
                <div v-if="selected_profile.phone !== ('' && ' ' )" class="flex align-middle justify-between mb2">
                  <p class=" small col-6">{{$t('eingabe_modal_select_creator_profile_phone')}}</p>
                  <p class="p col-6">{{selected_profile.phone}}</p>
                </div>
          
                <div v-if="selected_profile.company !== ('' && ' ' )" class="flex align-middle justify-between mb2">
                  <p class="small col-6">{{$t('eingabe_modal_select_creator_profile_company')}}</p>
                  <p class="p col-6">{{selected_profile.company}}</p>
                </div>
                <div v-if="selected_profile.address1 !== ('' && ' ' )" class="flex align-middle justify-between mb2">
                  <p class=" small col-6">{{$t('eingabe_modal_select_creator_profile_address_1')}}</p>
                  <p class="p col-6">{{selected_profile.address1}}</p>
                </div>
                <div v-if="selected_profile.address2 !== ('' && ' ' )" class="flex align-middle justify-between mb2">
                  <p class="small col-6">{{$t('eingabe_modal_select_creator_profile_address_2')}}</p>
                  <p class="p col-6">{{selected_profile.address2}}</p>
                </div>              
                <div v-if="selected_profile.address3 !== ('' && ' ' )" class="flex align-middle justify-between mb2">
                  <p class="psmall col-6">{{$t('eingabe_modal_select_creator_profile_address_3')}}</p>
                  <p class="p col-6">{{selected_profile.address3}}</p>
                </div>
                <div v-if="getCountry !== 0" class="flex align-middle justify-between mb2">
                  <p class="small col-6">{{$t('eingabe_modal_select_creator_profile_country')}}</p>
                  <p class="p col-6">{{getCountry}}</p>
                </div>
                <div v-if="selected_profile.previewimage !== ('' && ' ' )" class="flex justify-between">
                  <p class="small col-6">{{$t('eingabe_modal_select_creator_profile_logo')}}</p>
                  <div class="col-6">
                    <div v-if="selected_profile.previewimage !== ('' && ' ' )"  :style="{ 'background-image': `url(${selected_profile.previewimage.replace(/(\r\n|\n|\r)/gm, '')})` }" class="p4 rounded-border overflow-hidden bg-color-gray company-img-container"></div>
                  </div>
                </div>
              </div>
              <div class="col-6 px2 ">
                <div class="col-12 table-wrapper ">
                    <h2 class=" col-12 p mb2 pt2 white">
                      {{$t('eingabe_modal_select_creator_profile_creator_profile_name')}}
                    </h2>
                  <table class="product_select_table col-12">
                    <tr class="productusable productshown pointer" v-for="profile in creator_profiles" :key="profile.id" :class="{highlighted: profile.id == selected_profile.id}" @click="select_profile_from_table(profile)">
                      <td>{{ profile.title }}</td>
                    </tr>
                  </table>
              </div>
            </div>
        </div>

          <div class="col-12" v-if="creator_profiles.length == 0">
            <h2 class="h1 light white mb2">{{$t('eingabe_modal_select_creator_profile_no_profiles')}}</h2>
            <button class="btn btn-primary" @click="EBusEmit('open_add_single_CreatorProfileModal')">{{$t('eingabe_modal_select_creator_profile_add')}}</button>
          </div>


          <div class="modal-footer pt3 mt3 mr2 col-12">
            <div class="flex mr4 align-middle flex-end">
              <div>
                <button class="btn btn-small btn-bg-red self-end mr3" @click="closePdfExportModal()">{{$t('eingabe_modal_select_creator_profile_cancel_selection')}}</button>
              </div>
              <div v-if="creator_profiles.length > 0">
                <button class="btn btn-small self-end mr3" @click="EBusEmit('open_add_single_CreatorProfileModal')">{{$t('eingabe_modal_select_creator_profile_add')}}</button>
              </div>
              <div v-if="exportFromCalcCard == false">
                <button class="btn btn-small self-end mr3" :class="{'btn-bg-gray': creator_profiles.length == 0, 'npe': creator_profiles.length == 0}" @click="doPdfExportLink(selected_profile.id, $route.params.calculationid, $i18n.locale);" target="_blank">{{$t('eingabe_export_pdf_complete_btn_text_1')}} {{$t('eingabe_export_pdf_complete_btn_text_2')}}</button>
              </div>
              <div v-if="exportFromCalcCard == true">
                <button class="btn btn-small self-end mr3" :class="{'btn-bg-gray': creator_profiles.length == 0, 'npe': creator_profiles.length == 0}" @click="doPdfExportLink(selected_profile.id, calculationid, $i18n.locale);" target="_blank">{{$t('eingabe_export_pdf_complete_btn_text_1')}} {{$t('eingabe_export_pdf_complete_btn_text_2')}}</button>
              </div>
            </div>
          </div>
    </lightbox>


</div>
    
</template>

<script>
import axios from 'axios';
import { EventBus } from "../event-bus";
import lightbox from './lightbox.vue';

export default {
  name: 'createCreatorPofileModal',
  data() {
    return {
      debug: true,
      userProfile: {
        id: 0,
        title: '',
        previewimage: '',
        address1: '',
        address2: '',
        address3: '',
        company: '',
        email: '',
        phone: '',
        freePhone: 0,
        freeMail: 0,
        creator_name: '',
        country_id: ''
      },

      creator_profiles: [],
      selected_profile: {
        title: '',
        address1: '',
        address2: '',
        address3: '',
        company: '',
        country_id: 0,
        creator_name: '',
        email: '',
        phone: '',
        previewimage: '',
        id: ''
      },

      not_filled_title: false,
      not_filled_firstname: false,
      not_filled_lastname: false,
      not_filled_company: false,
      not_filled_email: false,
      not_filled_country: false,
      not_filled_address1: false,
      not_filled_creator_name: false,
      not_filled_phone: false,
      not_same_password: false,
      not_old_password: false,
      not_filled_previewimage: false,

      allIsValidated: true,

      // Login Daten
      userdata: {},
      session: {},
      loginStatus: false,

      countries_list: [],

      profileLoaded: false

    }
  },
  props: {
    'calculationid': String, 
    'exportFromCalcCard': Boolean
  },
  components: {
      'lightbox': lightbox,
  },
  created() {

    axios.get(process.env.VUE_APP_APIENDPOINT + "/public-api/get-countries/json").then(response => (this.countries_list = response.data));
    
    EventBus.$on('loginSuccessfulSubComponents', (payload) => {
      this.userdata = payload.userdata;
      this.session = payload.session;
      this.loginStatus = true;
      this.loadUserData()
    });
    EventBus.$on('loadUserProfileData', () => {
      this.loadUserData()
      this.loadCreatorProfiles()
    });
    EventBus.$on('collectDataForResultPDF-Step01', () => {
      EventBus.$emit('collectDataForResultPDF-Step02', {
        "appsettings_id": this.selected_project
      });
    });
        EventBus.$on('open_creatorProfileSelectionModal', () => {
  
      this.selected_profile.title = ''
      this.selected_profile.address1 = ''
      this.selected_profile.address2 = ''
      this.selected_profile.address3 = ''
      this.selected_profile.company = ''
      this.selected_profile.country_id = 0
      this.selected_profile.creator_name = ''
      this.selected_profile.email = ''
      this.selected_profile.phone = ''
      this.selected_profile.previewimage = ''
      this.selected_profile.id = ''

      this.loadCreatorProfiles()
      EventBus.$emit('open_creatorProfileSelection')
    });
    EventBus.$on('close_select_creator_profile_add_lightbox', () => {
      this.closeAddCreatorProfile();
    })
  },
  computed: {
    getCountry(){
      if(this.selected_profile.country_id !== 0){
        for (let i = 0; i < this.countries_list.data.length; i++) {
          if (this.countries_list.data[i].id == this.selected_profile.country_id) {
              return this.countries_list.data[i].countryname
          }
        }
      }else{
        return 0;
      }
      return 0;
    }
  },
  methods: {
    EBusEmit(command){
      console.log('emitting EventBus: ' + command)
      EventBus.$emit(command);
    },
    loadUserData(){
      if(!this.profileLoaded) {
        let url = process.env.VUE_APP_APIENDPOINT + '/public-api/loadmyprofile/json';
        axios.post(url, this.session)
        .then(response => {
          //(response.data)
          this.userGeneralData = response.data.userData;
          this.profileLoaded = true;
        })
        .catch(function () {
          console.log('catch Function of AJAX-Called... error()');
        });
      }
    },
    loadCreatorProfiles(){
      
      console.log('Loading Creator Profiles Called')
        let url = process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/creators-list/json';
        let currentObj = this;
        axios.post(url, currentObj.session)
        .then(response => {
          console.log(response.data.creators)
          currentObj.creator_profiles = response.data.creators;
          let cP = currentObj.creator_profiles
          for (let i = 0; i < cP.length; i++) {
            if(cP[i].address2 == ' '){
              cP[i].address2 = '';
            }
            if(cP[i].address3 == ' '){
              cP[i].address3 = '';
            }
            if(cP[i].previewimage == ' '){
              cP[i].previewimage = '';
            }
          }
        })
        .catch(function () {
          //console.log('catch Function of AJAX-Called... userprofileError()');
        });
    },
    addCreatorProfile(){
      //TODO: VALIDATION

      this.allIsValidated = true;

      if(this.userProfile.title == '') {
        this.not_filled_title = true;
        this.allIsValidated = false;
      }
      if(this.userProfile.company == '') {
        this.not_filled_company = true;
        this.allIsValidated = false;
      }
      if(this.userProfile.address1 == '') {
        this.not_filled_address1 = true;
        this.allIsValidated = false;
      }
      if(this.userProfile.country_id == '') {
        this.not_filled_country = true;
        this.allIsValidated = false;
      }
      if(this.userProfile.email == '' && this.userProfile.freeMail == 1) {
        this.not_filled_email = true;
        this.allIsValidated = false;
      }
      if(this.userProfile.phone == '' && this.userProfile.freePhone == 1) {
        this.not_filled_phone = true;
        this.allIsValidated = false;
      }
      if(this.userProfile.creator_name == '') {
        this.not_filled_creator_name = true;
        this.allIsValidated = false;
      }


      if(this.allIsValidated){
        let currentObj = this;
        let data = {};
        data = currentObj.userProfile
        if(currentObj.userProfile.freePhone == 0){
          data.phone = currentObj.userdata.tel;
        }
        if(currentObj.userProfile.freeMail == 0){
          data.email = currentObj.userdata.email;
        }
        let merged = {...data, ...this.session};
        axios.post(process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/creators-actions/add/json', merged)
            .then(function () {
              currentObj.loadCreatorProfiles();
              EventBus.$emit('close_add_single_CreatorProfileModal');
              EventBus.$emit('load_creator_profiles');
              currentObj.resetForm()
            }
        );

       
      }

    },
    closeAddCreatorProfile(){
      this.userProfile.id = 0;
      this.userProfile.title = '';
      this.userProfile.previewimage = '';
      this.userProfile.address1 = '';
      this.userProfile.address2 = '';
      this.userProfile.address3 = '';
      this.userProfile.company = '';
      this.userProfile.email = '';
      this.userProfile.phone = '';
      this.userProfile.freePhone = 0;
      this.userProfile.freeMail = 0;
      this.userProfile.creator_name = '';
      this.userProfile.country_id = '';
      EventBus.$emit('close_add_single_CreatorProfileModal');
      this.loadCreatorProfiles();
      this.resetForm();
    },
    changeFreeMail(value){
      if(value == 0){
        this.userProfile.freeMail = 1
        return
      }
      if(value == 1){
        this.userProfile.freeMail = 0
        return
      }
    },
    changeFreePhone(value){
      if(value == 0){
        this.userProfile.freePhone = 1
        return
      }
      if(value == 1){
        this.userProfile.freePhone = 0
        
        return
      }
    },

    selectImage () {
          this.$refs.fileInput.click()
      },
      pickFile () {
        this.previewimage = '';
        let input = this.$refs.fileInput
        let file = input.files
        if (file && file[0]) {
          let reader = new FileReader
          reader.onload = e => {
            this.userProfile.previewimage = e.target.result
          }
          reader.readAsDataURL(file[0])
          this.$emit('input', file[0])
        }
      },

      resetForm(){
        this.not_filled_title = false;
        this.not_filled_firstname = false;
        this.not_filled_lastname = false;
        this.not_filled_company = false;
        this.not_filled_email = false;
        this.not_filled_country = false;
        this.not_filled_address1 = false;
        this.not_filled_creator_name = false;
        this.not_filled_phone = false;
        this.not_same_password = false;
        this.not_old_password = false;
        this.not_filled_previewimage = false;

      },
    closePdfExportModal(){
      EventBus.$emit('close_creatorProfileSelection');

      this.selected_profile.title = ''
      this.selected_profile.address1 = ''
      this.selected_profile.address2 = ''
      this.selected_profile.address3 = ''
      this.selected_profile.company = ''
      this.selected_profile.country_id = 0
      this.selected_profile.creator_name = ''
      this.selected_profile.email = ''
      this.selected_profile.phone = ''
      this.selected_profile.previewimage = ''
      this.selected_profile.id = 0


      EventBus.$emit('reset_creator_profile_id')



    },
    select_profile_from_table(profile){
      var p = profile;
      this.selected_profile.title = p.title
      this.selected_profile.address1 = p.address1
      this.selected_profile.address2 = p.address2
      this.selected_profile.address3 = p.address3
      this.selected_profile.company = p.company
      this.selected_profile.country_id = p.country_id
      this.selected_profile.creator_name = p.creator_name
      this.selected_profile.email = p.email
      this.selected_profile.phone = p.phone
      this.selected_profile.previewimage = p.previewimage
      this.selected_profile.id = p.id

      EventBus.$emit('send_creator_profile_id', {
        'id': p.id,
        'lang': this.$i18n.locale
      });
    },

    doPdfExportLink(creatorid, calcid, lang) {
      let url =  process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/preparepdfexport/json';
      let data = {};
      let currentObj = this;

      data.calculationsid = calcid;
      data.creator_profile_id = creatorid;
      data.lang = lang;
      // data.creator_profile_id 
      
      let merged = {...data, ...currentObj.session};
     
      axios.post(url, merged)
        .then(response => {
          EventBus.$emit('close_creatorProfileSelection')
          if(response.data.success) {
            console.log('Ergebnis von Result: ')
            let result = window.open(response.data.link);
            console.log(result)
            if(result == null) {
              // MEldung ausgeben, das 
              alert('Bitte PopUp Blocker deaktivieren!')
            }
            // window.open(response.data.link);
          } else {
            alert('Leider trat ein unerwarteter Fehler bei der Erstellung der PDF-Datei auf!')
          }
        }).catch(function () {
          currentObj.log('catch Function of AJAX-Called... error()');
          
        });
    },
  }

}
</script>

<style scoped>
</style>